import {initializeApp} from "firebase/app";
import {getDatabase} from "firebase/database";
import {getMessaging, isSupported} from "firebase/messaging";
import {getFirestore} from "firebase/firestore";
import {browserLocalPersistence, getAuth, setPersistence} from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBinkf_bzky3TbUrXbcv6XkfRqAsbm2CsA",
    authDomain: "teache-39152.firebaseapp.com",
    databaseURL: "https://teache-39152-default-rtdb.firebaseio.com",
    projectId: "teache-39152",
    storageBucket: "teache-39152.appspot.com",
    messagingSenderId: "822655888239",
    appId: "1:822655888239:web:25e0e34919b949b962d69a",
    measurementId: "G-LG6D5L9QJK",
};

const firebaseApp = initializeApp(firebaseConfig);
const database = getDatabase(firebaseApp);
const firestore = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);

let messaging = {}

if (
    isSupported() &&
    'Notification' in window &&
    'serviceWorker' in navigator &&
    'PushManager' in window
) {
    messaging = getMessaging(firebaseApp);
}

setPersistence(auth, browserLocalPersistence).catch(() => {
});

export {database, messaging, firestore, auth};
